"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var bind_1 = require("../bind");
var form_group_1 = require("./form_group");
var FormGroupWithSelect = /** @class */ (function (_super) {
    tslib_1.__extends(FormGroupWithSelect, _super);
    function FormGroupWithSelect() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormGroupWithSelect.prototype.updateField = function (event) {
        if (!this.props.updateField)
            return;
        var attributes = {};
        var fieldToUpdate = this.props.fieldName || this.props.inputName;
        attributes[fieldToUpdate] = event.target.value;
        this.props.updateField(attributes);
    };
    FormGroupWithSelect.prototype.renderSelectOption = function (v, k) {
        return (React.createElement("option", { key: k, value: v.value, disabled: v.disabled }, v.text));
    };
    FormGroupWithSelect.prototype.valueIfControlled = function () {
        if (this.props.updateField)
            return { value: this.props.value };
    };
    FormGroupWithSelect.prototype.renderOptions = function () {
        var _this = this;
        if (this.props.optionGroups) {
            return this.props.optionGroups.map(function (group) {
                return (React.createElement("optgroup", { label: group.label, key: group.key }, group.options.map(_this.renderSelectOption)));
            });
        }
        return this.props.options.map(this.renderSelectOption);
    };
    FormGroupWithSelect.prototype.renderSelect = function () {
        return (React.createElement("div", { className: "styled-dropdown mb-0" },
            React.createElement("select", tslib_1.__assign({ onChange: this.updateField, required: this.props.required, id: this.props.id || this.props.inputName, name: this.props.inputName, disabled: this.props.disabled, autoFocus: this.props.autoFocus }, this.valueIfControlled()),
                this.props.addEmptyOption &&
                    React.createElement("option", { key: "empty-option", disabled: true, value: "" }, I18n.t('commons.selectFormGroup.selectOne')),
                this.renderOptions())));
    };
    FormGroupWithSelect.prototype.render = function () {
        return (React.createElement(form_group_1.default, { label: this.props.label, inputName: this.props.inputName, errorText: this.props.errorText, helpText: this.props.helpText, tagOptional: this.props.tagOptional, tagRecommended: this.props.tagRecommended, tagRequired: this.props.tagRequired }, this.renderSelect()));
    };
    tslib_1.__decorate([
        bind_1.default
    ], FormGroupWithSelect.prototype, "updateField", null);
    return FormGroupWithSelect;
}(React.Component));
exports.default = FormGroupWithSelect;
//# sourceMappingURL=form_group_with_select.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/components/form_group_with_select.js
// module id = czHq
// module chunks = 20 21 22